module.exports = __webpack_public_path__ + "img/7S.8343d3ef.svg";